import React from 'react';
import './MainSectionBooking.css';
import { FaWhatsapp, FaSms, FaCreditCard, FaExternalLinkAlt } from 'react-icons/fa';

const MainSectionBooking = () => {
  const phoneNumber = '+393382016803';
  const whatsappMessage = 'Hi, I would like to have info to book one of the tours offered!';

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  const handleSmsClick = () => {
    window.open(`sms:${phoneNumber}?body=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  return (
    <section
      className="booking-section"
      id="Booking"
      aria-labelledby="booking-heading"
      aria-describedby="booking-desc"
    >
      <div className="booking-container">
        <h2 id="booking-heading" className="booking-title">
          Book your private tour along the Amalfi Coast
        </h2>

        <p id="booking-desc" className="booking-description">
          Let yourself be guided through the secret coves and breathtaking views of the Coast,
          book now your private and live an unforgettable experience among caves,
          hidden beaches and crystal clear waters. Ask me information via whatsapp or sms.
        </p>

        <div className="WaSmsSumup_Section">
          <div className="booking-buttons">
            <button
              onClick={handleWhatsAppClick}
              className="whatsapp-button"
              aria-label="Prenota via WhatsApp"
            >
              <FaWhatsapp className="icon" aria-hidden="true" />
            </button>

            <button
              onClick={handleSmsClick}
              className="sms-button"
              aria-label="Invia SMS"
            >
              <FaSms className="icon" aria-hidden="true" />
            </button>
          </div>

          <div className="payment-methods">
            <h3 className="payment-title">
              <FaCreditCard className="sumup-icon" aria-hidden="true" /> Pay on board with SUMUP
            </h3>

            <ul className="payment-features">
              <li><span className="feature-icon">✓</span> Encrypted and secure transactions</li>
              <li><span className="feature-icon">✓</span> We accept all major credit cards</li>
              <li><span className="feature-icon">✓</span> Instant digital receipt</li>
              <li><span className="feature-icon">✓</span> No additional fees for you</li>
            </ul>

            <a
              href="https://www.sumup.com/it-it/"
              target="_blank"
              rel="noopener noreferrer"
              className="sumup-link"
              aria-label="Scopri di più su SUMUP, si apre in una nuova finestra"
            >
              Scopri di più su SUMUP <FaExternalLinkAlt className="link-icon" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainSectionBooking;
